/**
 * Language: English.
 */
export default {
    messages: {
        choose_thematic: "Choose Thematic",
        sessionReset: "Session will automatically reset in",
        minute: "minute",
        resetMap: "Reset Map",
        selectLanguage: "Select a Language",
        seconds: "seconds",
        cta: {
            "switch_standard_view": "Switch to standard view"
        },
        minutes: "minutes",
        multilevelwarning: "This is a multi-level path and goes via the Quick Link on Level 1",
    },
    thematics: {
        "outdoor": "Outdoor",
        "textile": "Textiles",
        "wallpaper": "Wallpaper",
        "kitchen": "Contractor Kitchens",
        "bathroom": "Bathroom Design",
    },
    thematicDescription: {
        "outdoor": "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces.",
        "textile": "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship.",
        "wallpaper": "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics.",
        "kitchen": "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces.",
        "bathroom": "Highly innovative interiors: water sustainability according to Salotto NY.",
    },
    errors: {
        loadingLibrary: "Failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors:{
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    },
};
